<div  class="dark-theme">
<wfm-system-notification
  class="u-mb---- sso-usage"
  [type]="'info-general'"
  [size]="'large'"
   *ngIf="showSSOUsageNotifiy"
  [headingText]="'cookie.usage.notification.msg' | translate"
  [multiLineLayout]="false"
  [hideCloseButton]="false"
  (close)="closeNotification()"
>
</wfm-system-notification>

<div
  class="sign-in-screen flex flex--middle flex--center "
  #container
  *ngIf="serviceUnavailable || isChangePasswordPage || loginPageNative || externalLogin || loginPageSSO"
>
<div
    class="
      sign-in-screen__box
      box box--border-none
      u-m--
      u-small-m+ u-ph- u-pv+ u-small-ph+++ u-small-pv++ u-medium-pv+++
    "
  >
    <div aria-label="GE monogram logo." class="text-align--center u-small-mt- u-medium-mt0">
      <div class="u-mb--">
        <svg-icon name="ico-ge-healthcare-stacked-logo" [svgStyle]="{ color: '#b39cf1', 'width.px': 316, 'height.px': 138 }">
        </svg-icon>
      </div>

      <div class="u-pt-">
        <div class="sign-in-screen__legend text-align--center u-smallest-mb-- u-small-mb++">
          {{ 'common.productName' | translate }}
        </div>
      </div>


      <div class="u-mb-- u-small-ph++ u-medium-ph+++" *ngIf="serviceUnavailable">
            <div role="alert" #errormsg class="form__error-text" id="serviceUnavailable">
              <svg-icon
                name="ico-form-error-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'margin-right.px': 4, fill: '#df4661' }"
              >
              </svg-icon>
              <span>
                <div [innerHTML]="'server.unavailable' | translate"></div>
                 <br/>
              </span>
            </div>
            <div class="form__error-text" id="serviceUnavailablemsg">
             <span>
              <div [innerHTML]="'server.down.error.message' | translate"></div>
             <br/>
              </span>
            </div>
            <hr class="u-mv0 u-mb---" />
            <div class="form__error-text" style="color: #b39cf1;" id="serviceUnavailablemsg">
             <span>
             <a href = "/login"
          id="login"
        >
          {{ 'log.in' | translate }}
        </a>
              </span>
            </div>
          </div>
    </div>



    <ng-container *ngIf="loginPageNative">
      <form (ngSubmit)="login()" [formGroup]="loginForm" method="post" class="u-small-ph++ u-medium-ph+++">
        <div class="container" *ngIf="notForDiagnosticUseMessageEnabled">
          <div id="warning" class="warning">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M22.81,20.39,13.11,1A1.8,1.8,0,0,0,9.89,1L.19,20.39A1.8,1.8,0,0,0,1.81,23H21.19A1.8,1.8,0,0,0,22.81,20.39Z" fill="#000"/>
              <path d="M11.5,21.38a1.88,1.88,0,1,1,1.88-1.88A1.88,1.88,0,0,1,11.5,21.38ZM13,14.5a1.5,1.5,0,0,1-3,0v-8a1.5,1.5,0,0,1,3,0Z" fill="#fff"/>
            </svg>
            <span>{{ 'label.notForDiagnosticUse' | translate }}</span>
          </div>
        </div>
        <fieldset class="form__fieldset u-p0 u-m0">
          <div class="u-small-mb u-smallest-mb--- u-mt-">
            <label class="form__label form__label--bottom" for="username">
              {{ 'login.usernameLabel' | translate }}
            </label>
            <input
              class="textbox textbox-login text-16"
              type="text"
              id="username"
              (focus)="clearMsg()"
              [attr.aria-invalid]="invalidEntry"
              formControlName="loginUsername"
              required
            />
          </div>
          <div class="u-smallest-pt- u-small-pt0 u-small-mb u-smallest-mb---">
            <label class="form__label form__label--bottom" for="password">
              {{ 'login.passwordLabel' | translate }}
            </label>
            <div class="sign-in-screen__pos-r">
              <input
                [attr.type]="hidePassword"
                [attr.aria-invalid]="invalidEntry"
                formControlName="loginPassword"
                (focus)="clearMsg()"
                class="textbox textbox-login text-16 u-pr+"
                id="password"
                autocomplete="off"
                #passwordField
                required
              />
              <app-toggle-password [hidePassword]="hidePassword" (toggleEvent)="togglePassword()"></app-toggle-password>
            </div>
          </div>

          <div class="u-mb--" *ngIf="loginErrorMessage">
            <div role="alert" #errormsg class="form__error-text" id="loginerrorMsg">
              <svg-icon
                name="ico-form-error-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'margin-right.px': 4, fill: '#df4661' }"
              >
              </svg-icon>
              <span>
                <div [innerHTML]="loginErrorMessage"></div>

                <div *ngIf="isMultiSessionRetryError" id="multiSessionError" class="u-pt-" [innerHTML]="multiSessionRetryWaitMessage">
                </div>
              </span>
            </div>
          </div>

          <div *ngIf="isMultiLoginError" id="multiLoginError">
            <div
              role="alert"
              class="form__error-text"
              id="multiLoginErrorMsg"
              [innerHTML]="'Application.errorPage.multiLogin.error' | translate"
            ></div>
          </div>

          <a
            id="reloginerror"
            class="errorMsg u-p--"
            href="#"
            *ngIf="isMultiLoginError"
            (click)="redirectToLoginPage()"
          >
            {{ 'Application.errorPage.multiLogin.allowUser' | translate }}
          </a>

          <button
            type="submit"
            id="loginButton"
            [wfmIntLog]="'SignIn'"
            [wfmIntLogInclude]="['click']"
            [disabled]="loginForm.invalid || clicked || isMultiLoginError"
            class="button button-login flex--center u--1/1 u-smallest-mt- u-small-mt0 u-smallest-mb--- u-small-mb--"
          >
            {{ 'login.loginButtonLabel' | translate }}
          </button>
        </fieldset>
      </form>

      <div class="u-pt- text-14 text-align--center u-small-ph++ u-medium-ph+++" *ngIf="updatePasswordFeature" >
        <a
          [class.archive-link]="!isAccountLocked"
          id="updatePassword"
          href="!"
          [class.hyperlink--disabled]="clicked || isMultiLoginError || isAccountLocked"
          (click)="changePasswordClicked(); $event.preventDefault()"
        >
          {{ 'login.changepwd' | translate }}
        </a>
      </div>
    </ng-container>

    <!-- SSO Code Started -->

    <ng-container *ngIf="loginPageSSO">
      <form (ngSubmit)="loginSSO()" [formGroup]="loginForm" method="post" class="u-small-ph++ u-medium-ph+++">
          <button
            type="submit"
            id="loginSSOButton"
            [wfmIntLog]="'SignIn'"
            [wfmIntLogInclude]="['click']"
            class="button button-login flex--center u--1/1 u-smallest-mt- u-small-mt0 u-smallest-mb--- u-small-mb--"
          >
            {{ 'loginSSO.loginSSOButtonLabel' | translate }}
          </button>
      </form>



      <div class="u-pt-  u-small-ph++ u-medium-ph+++" >
        <div class="text-14 text-align--center">
        <a href = "#"
          id="loginpageserviceuser"
          (click)="loginServiceUser(); $event.preventDefault()"
        >
          {{ 'loginSSO.service.user.in' | translate }}
        </a>
        </div>

        <div class="u-mb--" *ngIf="serviceUserloginErrorMessage">
            <div role="alert" #errormsg class="form__error-text" id="loginerrorMsg">
              <svg-icon
                name="ico-form-error-16"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'margin-right.px': 4, fill: '#df4661' }"
              >
              </svg-icon>
              <span>
                <div [innerHTML]="serviceUserloginErrorMessage"></div>
              </span>
            </div>
       </div>
      </div>

    </ng-container>
    <!-- SSO code ended -->

    <ng-container *ngIf="isChangePasswordPage">
      <form (ngSubmit)="changePassword()" [formGroup]="updatePasswordForm" method="post" class="u-m0 u-small-ph++">
        <fieldset class="form__fieldset u-p0 u-m0">
          <!-- User name -->
          <div class="u-mb-">
            <label class="form__label form__label--bottom" for="username">
              {{ 'login.usernameLabel' | translate }}
            </label>
            <input #loginUsername formControlName="loginUserName" class="textbox textbox-login text-16 u-pr+" id="chgpswusername" required />
            <ng-container
              *ngIf="changePasswordErrors.username"
              [ngTemplateOutlet]="errorMessageTemplate"
              [ngTemplateOutletContext]="{ message: changePasswordErrors.username, id: 'chgpswerrormsg' }"
            >
            </ng-container>
          </div>

          <!-- Old password -->
          <div class="u-mb-">
            <label class="form__label form__label--bottom" for="oldpwd">
              {{ 'changepwd.oldPasswordLabel' | translate }}
            </label>
            <div class="sign-in-screen__pos-r password-type-override">
              <input
                [attr.type]="hideOldPassword"
                formControlName="oldPassword"
                class="textbox textbox-login text-16 u-pr+"
                id="oldpwd"
                autocomplete="off"
                required
                #oldpassword
              />
              <app-toggle-password [hidePassword]="hideOldPassword" (toggleEvent)="toggleOldPassword()">
              </app-toggle-password>
            </div>
            <ng-container
              *ngIf="changePasswordErrors.oldPassword"
              [ngTemplateOutlet]="errorMessageTemplate"
              [ngTemplateOutletContext]="{ message: changePasswordErrors.oldPassword, id: 'chgpswerrormsg' }"
            ></ng-container>
          </div>

          <!-- New password -->
          <div class="u-mb-">
            <label class="form__label form__label--bottom" for="newpwd">
              {{ 'changepwd.newPasswordLabel' | translate }}
            </label>
            <div class="sign-in-screen__pos-r password-type-override">
              <input
                #newpassword
                [attr.type]="hideNewPassword"
                formControlName="newPassword"
                class="textbox textbox-login text-16 u-pr+"
                id="newpwd"
                autocomplete="off"
                [maxlength]="maxLength"
                required
                (keyup)="matchPassword()"
              />
              <app-toggle-password [hidePassword]="hideNewPassword" (toggleEvent)="toggleNewPassword()">
              </app-toggle-password>
            </div>
            <ng-container
              *ngIf="changePasswordErrors.newPassword"
              [ngTemplateOutlet]="errorMessageTemplate"
              [ngTemplateOutletContext]="{ message: changePasswordErrors.newPassword, id: 'chgpswerrormsg' }"
            ></ng-container>
          </div>

          <!-- confirm new password -->
          <div class="u-mb-">
            <label class="form__label form__label--bottom" for="cnfpwd">
              {{ 'changepwd.confirmNewPasswordLabel' | translate }}
            </label>
            <div class="sign-in-screen__pos-r password-type-override">
              <input
                #confirmpassword
                [attr.type]="hideConfirmPassword"
                formControlName="confirmNewPassword"
                class="textbox textbox-login text-16 u-pr+"
                id="cnfpwd"
                autocomplete="off"
                [maxlength]="maxLength"
                required
                (keyup)="matchPassword()"
              />
              <app-toggle-password [hidePassword]="hideConfirmPassword" (toggleEvent)="toggleConfirmPassword()">
              </app-toggle-password>
            </div>
            <ng-container
              *ngIf="changePasswordErrors.confirmNewPassword"
              [ngTemplateOutlet]="errorMessageTemplate"
              [ngTemplateOutletContext]="{ message: changePasswordErrors.confirmNewPassword, id: 'chgpswerrormsg' }"
            >
            </ng-container>
          </div>

          <ng-container
            *ngIf="changePasswordErrorMessage"
            [ngTemplateOutlet]="errorMessageTemplate"
            [ngTemplateOutletContext]="{ message: changePasswordErrorMessage, id: 'chgpswerrormsg' }"
          >
          </ng-container>

          <button
            id="changePwdButton"
            [disabled]="updatePasswordForm.invalid || isLoading || !updatePasswordFeature"
            type="submit"
            class="button button-login flex--center u--1/1"
            translate
          >
            changepwd.submitLabel
          </button>
        </fieldset>
      </form>

      <div class="u-pt text-14 text-align--center u-small-ph++ u-medium-ph+++">
        <a
          href="!"
          id="chgpswcancel"
          (click)="resetLoginForm(); isChangePasswordPage = false; loginPageNative = true; $event.preventDefault()"
          class="archive-link"
          translate
        >
          changepwd.cancelButtonText
        </a>
      </div>

      <div id="chgpswmultiLoginError" style="display: none; font-size: 20px">
        <h2></h2>
      </div>
      <div
        (click)="loginPageNative = true"
        class="archive-link"
        id="reloginerror"
        style="font-size: 20px; display: none"
      ></div>
    </ng-container>
    <ng-container *ngIf="externalLogin">
      <div class="filter__icon u-mr---" *ngIf="externalLoginSpinner">
        <wfm-spinner size="30"></wfm-spinner>
      </div>
      <div class="u-mb--" *ngIf="loginErrorMessage">
        <div role="alert" #errormsg class="form__error-text" id="externalloginerrorMsg">
          <svg-icon
            name="ico-form-error-16"
            [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'margin-right.px': 4, fill: '#df4661' }"
          >
          </svg-icon>
          <span>
            <div [innerHTML]="loginErrorMessage | translate"></div>
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
</div>
<div style="height: 100vh" *ngIf="expirePage">
  <label
    *ngIf="days === '-9999'"
    class="u-mt+++ form__label form__label--bottom flex--center"
    id="pwd-expired-message"
    for="un"
    translate
    >changepwd.error.expired</label
  >
  <label *ngIf="days !== '-9999'" class="u-mt+++ form__label form__label--bottom flex--center" id="pwd-expired-message">
    <span *ngIf="days !== '-9999'" id="pwd-error-message" translate
      >changepwd.error.updatePassword<span>&nbsp;</span></span
    >
    <span *ngIf="days === '0'" id="expiry-today" translate>changepwd.error.today<span>&nbsp;</span></span>
    <span *ngIf="days === '1'" id="expiry-in" translate>changepwd.error.in<span>&nbsp;</span></span>
    <span *ngIf="days === '1'" id="expiry-in-day">{{ days }}<span>&nbsp;</span></span>
    <span *ngIf="days === '1'" id="expiry-day" translate>changepwd.error.day</span>
    <span *ngIf="days !== '1' && days !== '0'" id="expiry-error-in" translate
      >changepwd.error.in<span>&nbsp;</span></span
    >
    <span *ngIf="days !== '1' && days !== '0'" id="expiry-in-days">{{ days }}<span>&nbsp;</span></span>
    <span *ngIf="days !== '1' && days !== '0'" id="expiry-error-days" translate>changepwd.error.days&nbsp;</span>
  </label>
  <label *ngIf="" class="u-mt+++ form__label form__label--bottom flex--center" for="un" translate
    >changepwd.error.expired</label
  >
  <div class="flex flex--center" *ngIf="passwordExpired">
    <button
      id="changePwdButton"
      (click)="changePasswordForm()"
      class="button button-login flex--center"
      translate
      *ngIf="updatePasswordFeature"
    >
      login.changepwd
    </button>
    <button
      *ngIf="days !== '-9999'"
      id="loginButton"
      (click)="continue()"
      class="continue-width button button-login flex--center"
      [ngClass]="{ 'u-ml+': updatePasswordFeature }"
      translate
    >
      changepwd.error.continue
    </button>
  </div>
</div>

<ng-template #errorMessageTemplate let-message="message" let-id="id">
  <div class="u-mb--">
    <div role="alert" #errormsg class="form__error-text" [id]="id">
      <svg-icon
        name="ico-form-error-16"
        [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'margin-right.px': 4, fill: '#df4661' }"
      >
      </svg-icon>
      <span [innerHTML]="message | translate"></span>
    </div>
  </div>
</ng-template>
